'use strict';

var TRIM_CHARS = require('../../common/var/TRIM_CHARS');

module.exports = RegExp('^['+ TRIM_CHARS +']+');


//////////////////
// WEBPACK FOOTER
// ./~/sugar/string/var/LEFT_TRIM_REG.js
// module id = 946
// module chunks = 0